import { useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';

import { DepositHeader } from './DepositHeader';

interface DepositListViewProps {
  title: string;
  searchTerm?: string;
  setSearchTerm?: (val: string) => void;
  onBack: () => void;
  children: React.ReactNode;
  balance: number;
  onClose: () => void;
}

export const DepositListView = ({
  title,
  searchTerm,
  setSearchTerm,
  onBack,
  children,
  balance,
  onClose,
}: DepositListViewProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (setSearchTerm !== undefined) {
      inputRef.current?.focus();
    }
  }, [setSearchTerm]);

  return (
    <Box className="absolute inset-0 z-[100] flex h-full animate-[dm-slideRight_0.4s_cubic-bezier(0.16,1,0.3,1)] flex-col rounded-[32px] bg-[var(--bg-primary)] p-6 dark:bg-[var(--bg-primary)]">
      <DepositHeader title={title} onBack={onBack} balance={balance} onClose={onClose} />

      {setSearchTerm !== undefined && (
        <Box className="relative mb-6">
          <SearchIcon
            className="absolute left-4 top-1/2 -translate-y-1/2 text-[var(--text-muted)]"
            sx={{ fontSize: 20 }}
          />
          <input
            ref={inputRef}
            className="w-full rounded-2xl border border-[var(--border-color)] bg-transparent py-4 pl-12 pr-4 text-base text-[var(--text-primary)] outline-none transition-all focus:border-[var(--text-primary)]"
            placeholder=" "
            value={searchTerm}
            onChange={(e) => setSearchTerm?.(e.target.value)}
          />
        </Box>
      )}

      <Box className="scrollbar-none mt-2 flex-1 snap-y overflow-y-auto pr-1">{children}</Box>
    </Box>
  );
};
